import HousekeepingMainPage from "../../components/housekeepingV2/HousekeepingMainPage";

const Index = () => {
  return <HousekeepingMainPage />;
};

export default Index;
